import { Reveal, SectionLabel } from "@/components/Reveal";
import { EMAIL, EMAIL_MAILTO, usePageTitle } from "@/lib/data";

const sections = [
  {
    title: "Informational purposes only",
    body: "The content on this website is provided for general informational purposes. It is not legal, financial, tax, or real estate advice, and it does not create an attorney-client, agency, or advisory relationship. Every property situation is different; please consult qualified professionals before making decisions.",
  },
  {
    title: "No obligation",
    body: "Contacting PRG, requesting a consultation, or submitting the intake form creates no obligation on your part or ours. Consultations are free, and you may end the conversation at any time, for any reason.",
  },
  {
    title: "Accuracy of information",
    body: "We work hard to keep the information on this site accurate and current, but we make no warranties about completeness or accuracy. Timelines and outcomes described here are illustrative, not guarantees.",
  },
  {
    title: "Use of this website",
    body: "You agree to use this site lawfully and respectfully. You may not attempt to access systems or data that are not intended for you, or use the site in any way that could harm PRG or the homeowners we serve.",
  },
  {
    title: "Limitation of liability",
    body: "To the fullest extent permitted by law, PRG is not liable for any indirect, incidental, or consequential damages arising from your use of this website or reliance on its content.",
  },
  {
    title: "Governing law",
    body: "These terms are governed by the laws of the State of Florida. Any disputes will be resolved in the state or federal courts located in Central Florida.",
  },
  {
    title: "Changes to these terms",
    body: "We may update these terms from time to time. The current version will always be posted on this page with its effective date.",
  },
];

export default function Terms() {
  usePageTitle("Terms of Use");
  return (
    <section data-testid="terms-page" className="pt-44 pb-28">
      <div className="mx-auto max-w-3xl px-6">
        <Reveal>
          <SectionLabel>Terms of Use</SectionLabel>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-night leading-tight">
            Clear terms, in plain language.
          </h1>
          <p className="mt-6 text-charcoal leading-relaxed text-lg">
            Effective July 2026. By using this website, you agree to the terms below.
          </p>
        </Reveal>
        <div className="mt-14 space-y-12">
          {sections.map((s) => (
            <Reveal key={s.title}>
              <h2 className="font-serif text-2xl sm:text-3xl text-night">{s.title}</h2>
              <p className="mt-4 text-charcoal leading-relaxed">{s.body}</p>
            </Reveal>
          ))}
          <Reveal>
            <h2 className="font-serif text-2xl sm:text-3xl text-night">Questions</h2>
            <p className="mt-4 text-charcoal leading-relaxed">
              Questions about these terms? Email{" "}
              <a href={EMAIL_MAILTO} data-testid="terms-email-link" className="text-sage-deep underline underline-offset-4 hover:text-night transition-colors duration-300">{EMAIL}</a>.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
